import gql from "graphql-tag";
import {
  type CurrentUserResult,
  type PermissionSchema,
  type UserNode,
  type UserResultData,
} from "../types/logic";
import {RoleElement} from "@superloop/zion-permissions/types";

export const getPermissionsQuery = gql`
query getPermissionsQuery {
  classMethods {
    User {
      getPermissions {
        name
        schema
      }
    }
  }
}`;
export function getPermissionsResult(result: UserResultData): RoleElement | undefined {
  if (result?.data?.classMethods?.User?.getPermissions !== undefined) {
    return result.data.classMethods.User.getPermissions;
  }

  if (result?.data?.getPermissions !== undefined) {
    return result.data.getPermissions;
  }

  return undefined;
}


export const getCurrentUserWithGroupQuery = gql`
query getCurrentUserQuery {
  classMethods {
    User {
      getCurrentUser {
        id
        firstName
        lastName
        email
        disabled
        userName
        createdAt
        role {
          name
        }
        groups {
          edges {
            node{
              id
              name
            }
          }
        }
      }
    }
  }
}
`;
export const getCurrentUserQuery = gql`
query getCurrentUserQuery {
  classMethods {
    User {
      getCurrentUser {
        id
        firstName
        lastName
        intercomId
        jwtToken
        hasUserTOTP
        email
        disabled
        requireAcceptTNC
        userName
        createdAt
        role {
          id
          name
        }
      }
    }
  }
}
`;



export function getCurrentUserResult(result: UserResultData): CurrentUserResult {
  const user = result.data?.classMethods?.User?.getCurrentUser;

  if (!user) {
    return {};
  }

  const mappedUser: UserNode = {...user};
  if (
    mappedUser.groups &&
    !Array.isArray(mappedUser.groups) &&
    "edges" in mappedUser.groups
  ) {
    mappedUser.groups = mappedUser.groups.edges?.map((g) => g.node) || [];
  }

  return {
    user: mappedUser,
    schema: mappedUser.permissions,
  };
}


export const loginMutation = gql`
mutation loginMutation($username: String, $password: String){
  classMethods {
    User {
      login(userName: $username, password: $password) {
        success
        requireRadius
        authLocation
        targetLocation
      }
    }
  }
}
`;

export const loginMutationOptions = {
  name: "loginMutation",
  options: {
    refetchQueries: [{query: getCurrentUserQuery}],
    awaitRefetchQueries: true,
  },
};
// export const login = graphql(loginMutation, loginMutationOptions);

export function loginResult(results: UserResultData) {
  return results.data?.classMethods?.User?.login;
}

export const logoutMutation = gql`
  mutation logout {
    classMethods {
      User {
        logout
      }
    }
  }
`;
export const logoutMutationOptions = {
  name: "logout",
  options: {
    refetchQueries: [
      {query: getCurrentUserQuery},
    ],
  },
};
// export const logout = graphql(logoutMutation, logoutMutationOptions);



export const getSiteInfoQuery = gql`
query getSiteInfo {
  siteInfo {
    code
    intercomAppId
    logdnaApiKey
    logdnaDebugLevel
    auEwayClientKey
  }
}`;

export function getSiteInfoResult(result: UserResultData) {
  if (!result.data) {
    return undefined;
  }
  return result.data.siteInfo;
}

export const acceptTNCMutation = gql`
  mutation acceptTnc {
    classMethods {
      User {
        acceptTnc
      }
    }
  }
`;


